'use client';

import { FC, useEffect } from 'react';

import { NotFoundBlogPage } from '@telialt/public-web-content/src/components/Common/NotFoundBlogPage/NotFoundBlogPage';
import { datadogLogger } from '@telialt/utils/src/datadog/datadogLogger';
import { DDComponent } from '@telialt/utils/src/datadog/setup';

const NotFound: FC = () => {
    useEffect(() => {
        const datadogLogs = datadogLogger();
        datadogLogs.error(`Blog page not found. Code: 404`, { component: DDComponent.PublicWeb });
    }, []);

    return <NotFoundBlogPage />;
};

export default NotFound;
